import { camelCase } from 'lodash';
import { getLogger } from '$util/logger';
import type { CmsPageCollectionItems } from '$cms/types';

/**
 *
 * @param location the URL object of the page location
 * @param pathPattern a string of the url path containing the collections used in placeholders
 * @param collections CmsPageCollectionItems which should contain the collections used in placeholder
 * @returns string of the canonical url with the relevant placeholders replaced with the name of there respective collection if present in the supplied collections
 */
export function generateCanonicalUrlForCollections(
  location: URL,
  pathPattern: URL['pathname'],
  collections: CmsPageCollectionItems
): string | undefined {
  const placeholderRegex = /\{([A-z-]+)\}/g;
  const placeholders = pathPattern.matchAll(placeholderRegex);

  let workingString = pathPattern;

  let placeholder = placeholders.next();

  while (!placeholder.done) {
    const collectionName = camelCase(placeholder.value[1]);
    const rightCollection = collections[collectionName as keyof CmsPageCollectionItems];

    if (rightCollection) {
      workingString = workingString.replace(placeholder.value[0], rightCollection.slug);
    }

    placeholder = placeholders.next();
  }

  const unreplacedPlaceholders = workingString.match(placeholderRegex);
  if (!unreplacedPlaceholders) {
    return `${location.origin}${workingString}`;
  }
  const log = getLogger(generateCanonicalUrlForCollections.name);

  log.error(
    {
      pathPattern,
      unreplacedPlaceholders,
    },
    'Unable to generate canonical url for path pattern'
  );

  return undefined;
}
